/**
 * Company: SPHMedia
 * Description: [RestaurantSearch component description]
 */

import SearchIcon from "@assets/restaurant/search.svg";
import { MAX_SEARCH_LENGTH } from "@config/kakiMakan";
import { useBHCustomEventAnalyticsCall } from "@hooks/useAnalyticsCall/useBHCustomEventAnalyticsCall";
import { ReactElement } from "react";

import useRestaurantSearch from "./hooks/useRestaurantSearch";

export type RestaurantSearchProps = {
  onSearch: (query: string) => void;
  id?: string;
  placeholder?: string;
};

/**
 * RestaurantSearch
 * Description: [RestaurantSearch component for kaki makan page]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function RestaurantSearch({
  onSearch,
  id = "restaurant-search",
  placeholder = "Search for restaurant",
}: RestaurantSearchProps): ReactElement {
  const bhCustomEvent = useBHCustomEventAnalyticsCall();
  const { debouncedSearch, handleKeyPress } = useRestaurantSearch({
    bhCustomEvent,
    onSearch,
  });

  return (
    <div className="flex justify-center w-full">
      <input
        id={id}
        type="search"
        placeholder={placeholder}
        maxLength={MAX_SEARCH_LENGTH}
        onChange={(e) => {
          debouncedSearch(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            debouncedSearch.cancel(); // cancel any pending debounce
            handleKeyPress((e.target as HTMLInputElement).value);
          }
        }}
        data-testid="restaurant-search-input"
        className="w-full max-w-[650px] min-w-[320px] bg-white-200 bg-no-repeat border border-solid border-black-700 py-3 px-4 pr-10 text-sm leading-[150%] text-black-700 font-medium"
        style={{
          backgroundImage: `url("${SearchIcon}")`,
          backgroundPosition: "right 16px center",
        }}
      />
    </div>
  );
}
